import React, { CSSProperties, ReactNode } from "react";
import { colors } from "../../styles";
import { Button } from "./Button";

type SMALL_BUTTON_TYPE = "orange" | "default" | "disabled" | "outlined";

interface SmallButtonProps {
  children: ReactNode;
  onClick: () => void;
  type: SMALL_BUTTON_TYPE;
}

export default function SmallButton({
  children,
  onClick,
  type,
}: SmallButtonProps) {
  const buttonTypeToStyle = (type: SMALL_BUTTON_TYPE): CSSProperties => {
    switch (type) {
      case "orange":
        return { background: colors.orange650, color: "white" };
      case "default":
        return { background: "#000", color: "white" };
      case "disabled":
        return { background: colors.gray200, color: "white" };
      case "outlined":
        return {
          background: colors.white,
          border: `1px solid ${colors.gray300}`,
          borderRadius: "5px",
        };
      default:
        return {};
      // break;
    }
  };

  return (
    <Button
      style={{
        padding: "10px 20px",
        borderRadius: "5px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        ...buttonTypeToStyle(type),
      }}
      onClick={onClick}
      className="button"
    >
      {children}
    </Button>
  );
}
